import { base_colorContentBorder, grey100 } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  padding: ${spacing(6)};
  background-color: ${grey100};
  border: 1px solid ${base_colorContentBorder};
  border-radius: 10px;

  .container-inner {
    position: relative;
  }

  .issuer-img {
    width: 73px;
  }

  .bottom-spacer-1 {
    padding-bottom: ${spacing(1)};
  }

  .bottom-spacer-2 {
    padding-bottom: ${spacing(2)};
  }

  .card-type-spacer {
    padding-top: ${spacing(3)};
  }

  .address-column {
    // hax
    width: 272px;
  }
`
